import {AnyAction, Dispatch} from "@reduxjs/toolkit";
import {api} from "@core/api";

const invalidateChatbot = (dispatch: Dispatch<AnyAction>) => {
  dispatch(api.util.invalidateTags(["chatbot"]));
};

export {invalidateChatbot};
